const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');
const CloverReceiptDeliveryMethod = require('@/lib/PaymentMethods/Clover/Enums/CloverReceiptDeliveryMethod');

class CloverReceiptCreditRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @param {string} creditId // A uuid.
     * @param {} deliveryOption
     */
    constructor(creditId, deliveryOption) {
        if (!creditId || creditId.trim() === '') {
            throw new Error('creditId is required');
        }
        if (
            // @Todo test against actual DeliveryOption object.
            !deliveryOption
            || !deliveryOption.method
            || !CloverReceiptDeliveryMethod.hasOwnProperty(deliveryOption.method)
        ) {
            const methods = Object.values(CloverReceiptDeliveryMethod).join(', ');
            throw new Error('deliveryOption is required and must be one of ' + methods);
        }
        // @link https://docs.clover.com/reference/deliver_credit_receipt
        const url = '/connect/v1/credits/' + creditId + '/receipt';
        super(
            'POST',
            url
        );
        this.data = {
            // printJobId
            deliveryOption,
        };
    }
}

module.exports = CloverReceiptCreditRequestRecord;
